function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MapBoxResetControl = /*#__PURE__*/function () {
  function MapBoxResetControl() {
    _classCallCheck(this, MapBoxResetControl);
  }
  return _createClass(MapBoxResetControl, [{
    key: "onAdd",
    value: function onAdd(map) {
      this._map = map;
      this._container = document.createElement('div');
      this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
      this._container.appendChild(this.createButton('reset_button'));
      return this._container;
    }
  }, {
    key: "createButton",
    value: function createButton(className) {
      var _this = this;
      var btn = document.createElement('button');
      btn.className = className;
      var icon = document.createElement('i');
      icon.className = 'fas fa-redo';
      btn.appendChild(icon);
      btn.addEventListener('click', function (e) {
        // window.location.reload()
        // return;
        // TODO, ensure this is geolocate control
        _this._map._controls[3].clear();
        _this._map.flyTo(_this._map.resetView);
        window.dataLayer.push({
          event: 'locator_reset'
        });
        e.stopPropagation();
      }, false);
      return btn;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    }
  }]);
}();
export { MapBoxResetControl as default };